import { Slider } from '@quillbot/design-system';

import withStyles from '@mui/styles/withStyles';

interface Props {
  [key: string]: any;
}
const sliderBoxShadow =
  '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)';
const primaryThumbShadow =
  '0 1px 1px rgba(0,0,0,0.1), 0 4px 4px rgba(0,0,0,0.03), 0 0 0 1px rgba(0,0,0,0.01)';
export const MySlider = withStyles((theme) => ({
  root: {
    color: theme.palette.primary.main,
    height: 3,
    width: (props: Props) => props.width,
    padding: '2px 0',
    // borderRadius: '10px',
  },
  thumb: {
    height: (props: Props) => (props.thumheight === undefined ? 12 : props.thumheight),
    width: (props: Props) => (props.thumwidth === undefined ? 12 : props.thumwidth),
    backgroundColor: '#fff',
    boxShadow: primaryThumbShadow,
    display: (props: Props) => (props.hidethumb === 'true' ? 'none' : 'flex'),
    // marginTop: -5.5,
    // marginLeft: -5,
    border: '#B3B3B6 0.5px solid',
    // borderRadius: '10px',
    '&:hover,&$active': {
      boxShadow: '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.2),0 0 0 1px rgba(0,0,0,0.02)',
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        boxShadow: sliderBoxShadow,
      },
    },
    '&.Mui-focusVisible': {
      boxShadow: primaryThumbShadow,
    },
  },
  valueLabel: {
    left: 'calc(-50% + 11px)',
    top: -22,
    '& *': {
      background: 'transparent',
      color: '#000',
    },
  },
  track: {
    height: 'inherit',
    border: 'none',
  },
  rail: {
    height: 'inherit',
    opacity: 0.5,
    backgroundColor: '#bfbfbf',
    width: (props: Props) => props.railwidth,
  },
  mark: {
    backgroundColor: '#a9a9a9',
  },
  markActive: {
    opacity: 1,
    backgroundColor: '#32643B',
  },
}))(Slider);
